const axios = require("axios").default;

const URL = `${process.env.REACT_APP_API_URL}/return/reject`;
const URL_RETURN = `${process.env.REACT_APP_API_URL}/return`;
const URL_BACK_CUSTOMER = `${process.env.REACT_APP_API_URL}/return/backtocustomer`;

export const getAll = (payload) => {
  return axios.get(URL, {
    params: payload,
  });
};

export const postApproval = (payload) => {
  return axios.post(`${URL_RETURN}`, payload);
};

export const postBackCustomer = (payload) => {
  return axios.post(`${URL_BACK_CUSTOMER}`, payload);
};

